import { SETTINGS_V2_RESOURCES, PAGE_NAMES, PERMISSIONS_MANAGEMENT_RESOURCES } from '../../../settingsV2Constant';
import permissions from '../../../assets/settingsV2/permissions.png';
import permissionsSet from '../../../assets/settingsV2/permissionsSet.png';
import bulkPermissions from '../../../assets/settingsV2/bulkPermissions.png';
import bulkPermissionCsv from '../../../assets/settingsV2/permission.svg';

import PermissionsDashboard from './permissions';
import PermissionsSetDashboard from './permissionsSet';
import BulkPermissionsDashboard from './bulkPermissions';
import BulkPermissionCsvDashboard from './bulkPermissionCsv';

export const URL = {
	[PERMISSIONS_MANAGEMENT_RESOURCES.permission]: `/${PAGE_NAMES.settingsV2}/${SETTINGS_V2_RESOURCES.permissionsManagement}/${PERMISSIONS_MANAGEMENT_RESOURCES.permission}`,
	[PERMISSIONS_MANAGEMENT_RESOURCES.permissionSet]: `/${PAGE_NAMES.settingsV2}/${SETTINGS_V2_RESOURCES.permissionsManagement}/${PERMISSIONS_MANAGEMENT_RESOURCES.permissionSet}`,
	[PERMISSIONS_MANAGEMENT_RESOURCES.bulkPermission]: `/${PAGE_NAMES.settingsV2}/${SETTINGS_V2_RESOURCES.permissionsManagement}/${PERMISSIONS_MANAGEMENT_RESOURCES.bulkPermission}`,
	[PERMISSIONS_MANAGEMENT_RESOURCES.bulkPermissionCsv]: `/${PAGE_NAMES.settingsV2}/${SETTINGS_V2_RESOURCES.permissionsManagement}/${PERMISSIONS_MANAGEMENT_RESOURCES.bulkPermissionCsv}`
};

export const LABEL = {
	[PERMISSIONS_MANAGEMENT_RESOURCES.permission]: 'Permissions',
	[PERMISSIONS_MANAGEMENT_RESOURCES.permissionSet]: 'Permissions Set',
	[PERMISSIONS_MANAGEMENT_RESOURCES.bulkPermission]: 'Bulk Permissions',
	[PERMISSIONS_MANAGEMENT_RESOURCES.bulkPermissionCsv]: 'Bulk Permission CSV'
};

export const COMPONENT = {
	[PERMISSIONS_MANAGEMENT_RESOURCES.permission]: PermissionsDashboard,
	[PERMISSIONS_MANAGEMENT_RESOURCES.permissionSet]: PermissionsSetDashboard,
	[PERMISSIONS_MANAGEMENT_RESOURCES.bulkPermission]: BulkPermissionsDashboard,
	[PERMISSIONS_MANAGEMENT_RESOURCES.bulkPermissionCsv]: BulkPermissionCsvDashboard
};

export const IMAGE_SOURCE = {
	[PERMISSIONS_MANAGEMENT_RESOURCES.permission]: permissions,
	[PERMISSIONS_MANAGEMENT_RESOURCES.permissionSet]: permissionsSet,
	[PERMISSIONS_MANAGEMENT_RESOURCES.bulkPermission]: bulkPermissions,
	[PERMISSIONS_MANAGEMENT_RESOURCES.bulkPermissionCsv]: bulkPermissionCsv
};
